import { useAuth } from "../context/AuthContext.jsx";

export function useCurrentUser() {
  const { user, status, refetch } = useAuth();
  return {
    user: status === "authenticated" ? user : null,
    isLoading: status === "loading",
    error: null,
    refetch,
  };
}
